import React from 'react';
import { Calendar, MapPin, Phone, Mail, CheckCircle } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const ContactSection = ({ type }) => {
  const benefits = [
    'Free 30-minute consultation',
    'No obligation assessment',
    'Expert funding guidance',
    'Personalised recommendations'
  ];

  return (
    <section id="contact" className="relative bg-black py-24 lg:py-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-[#4A90A4]/10 via-transparent to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#4A90A4] text-sm font-semibold uppercase tracking-wider mb-4 block">Get In Touch</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Let's <span className="text-[#4A90A4]">Talk</span>
          </h2>
          <p className="text-white/60 text-lg">
            {type === 'innovation' 
              ? 'Ready to discover how much innovation funding your business could unlock? Book a complimentary consultation with our team.'
              : 'Ready to transform your operations? Let\'s discuss how we can help you achieve operational excellence.'
            }
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {/* Left - Calendly */}
          <div className="space-y-8">
            {/* Calendly Embed */}
            <div className="bg-white/[0.02] border border-white/10 p-8">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-[#4A90A4] flex items-center justify-center">
                  <Calendar size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white">Book a Consultation</h3>
                  <p className="text-white/50 text-sm">30-minute complimentary session</p>
                </div>
              </div>
              <div className="bg-white rounded overflow-hidden" style={{ minHeight: '400px' }}>
                <iframe
                  src="https://calendly.com/projects-philcanindustries?hide_gdpr_banner=1&background_color=ffffff&text_color=1a1a1a&primary_color=4A90A4"
                  width="100%"
                  height="400"
                  frameBorder="0"
                  title="Schedule a consultation"
                  className="w-full"
                />
              </div>
            </div>

            {/* Benefits */}
            <div className="space-y-3">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle size={18} className="text-[#4A90A4]" />
                  <span className="text-white/70">{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right - Contact Details */}
          <div className="space-y-8">
            <div className="bg-white/[0.02] border border-white/10 p-8">
              <h3 className="text-xl font-semibold text-white mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#4A90A4]/10 flex items-center justify-center">
                    <Phone size={20} className="text-[#4A90A4]" />
                  </div>
                  <div>
                    <p className="text-white/50 text-sm">Phone</p>
                    <a href={`tel:${companyInfo.phone}`} className="text-white hover:text-[#4A90A4] transition-colors">
                      {companyInfo.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#4A90A4]/10 flex items-center justify-center">
                    <Mail size={20} className="text-[#4A90A4]" />
                  </div>
                  <div>
                    <p className="text-white/50 text-sm">Email</p>
                    <a href={`mailto:${companyInfo.email}`} className="text-white hover:text-[#4A90A4] transition-colors">
                      {companyInfo.email}
                    </a>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 bg-[#4A90A4]/10 flex items-center justify-center">
                    <MapPin size={20} className="text-[#4A90A4]" />
                  </div>
                  <div>
                    <p className="text-white/50 text-sm">Location</p>
                    <span className="text-white">{companyInfo.address}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Contact CTA */}
            <div className="bg-gradient-to-br from-[#4A90A4]/20 to-transparent border border-[#4A90A4]/30 p-8 text-center">
              <h4 className="text-lg font-semibold text-white mb-2">Prefer to email directly?</h4>
              <p className="text-white/60 text-sm mb-6">We typically respond within 24 hours</p>
              <a 
                href={`mailto:${companyInfo.email}`}
                className="inline-flex items-center gap-2 bg-[#4A90A4] text-white px-6 py-3 font-medium hover:bg-[#5BA0B4] transition-all duration-300"
              >
                <Mail size={18} />
                Send Us an Email
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
